import React, { lazy } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LazyLoader from '../components/LazyLoader';

const Services = lazy(() => import('../components/services/Services'));

const ServicesPage = () => {
    const theme = useTheme();
    return (
        <Box sx={{ p: 4, background: theme.palette.background.default }}>
            <LazyLoader>
                <Services />
            </LazyLoader>
        </Box>
    );
};

export default ServicesPage; 